// Chunk array into array of arrays, each array having chunkSize length
export function chunkArray(array, chunkSize) {
  return [].concat.apply(
    [],
    array.map(function(elem, i) {
      return i % chunkSize ? [] : [array.slice(i, i + chunkSize)];
    })
  );
}

export function checkAccountEditPermission({ permissions, currentUser }) {
  const currentUserID = currentUser.get('_id');
  return (
    permissions.toList().filter(permission => {
      return (
        permission.user_id === currentUserID &&
        permission.permissions.edit.account
      );
    }).size > 0
  );
}



// WEBPACK FOOTER //
// ./src/components/Utilities/index.js